import React from 'react';

import ListItemIcon from '@liquidweb-dev/undercurrent/ListItemIcon';
import ListItemText, {
	listItemTextClasses,
} from '@liquidweb-dev/undercurrent/ListItemText';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';

/**
 * @typedef {import('@liquidweb-dev/undercurrent').SxProps<import('@liquidweb-dev/undercurrent').Theme>} MuiSxStylesI
 */

/** @type {MuiSxStylesI} */
const baseHoverStyles = (theme) => ({
	color: theme.palette.uc.highlight.text.main,
	bgcolor: theme.palette.uc.highlight.bg.weak,

	[`.${listItemTextClasses.secondary}`]: {
		color: theme.palette.uc.highlight.text.main,
	},
});

/** @type {MuiSxStylesI} */
const baseStyles = (theme) => ({
	color: theme.palette.text.primary,
	paddingX: 200,
	paddingY: 150,
	gap: 150,
	':hover': baseHoverStyles,
	':active': baseHoverStyles,
	':focus-visible': {
		outlineOffset: '2px',
		outlineWidth: '2px',
		outlineStyle: 'solid',
		outlineColor: theme.palette.uc.highlight.border.main,
	},
});

/**
 * @typedef CreateItemPropsI
 * @property {React.Node} [icon]
 * @property {React.Node} [endIcon]
 * @property {string} [description]
 * @property {React.Node} children
 */

/**
 * @param {React.ComponentProps<typeof MenuItem> & CreateItemPropsI} props
 */
export function CreateItem(props) {
	const { icon, endIcon, description, children, sx, ...menuItemProps } = props;

	return (
		<MenuItem sx={[baseStyles, sx]} {...menuItemProps}>
			{icon && <ListItemIcon>{icon}</ListItemIcon>}
			<ListItemText
				primary={children}
				secondary={description}
				slotProps={{
					primary: {
						sx: {
							fontWeight: 500,
						},
					},
					secondary: {
						sx: {
							[`&.${listItemTextClasses.secondary}`]: {
								typography: 'body-xs',
								color: ({ palette }) => palette.uc.text.main,
							},
						},
					},
				}}
				sx={{ display: 'block' }}
			/>
			{endIcon && (
				<ListItemIcon sx={{ justifyContent: 'flex-end' }}>
					{endIcon}
				</ListItemIcon>
			)}
		</MenuItem>
	);
}
export default CreateItem;
